let pawnshop_reports_reader_domain =
  process.env.REACT_APP_PAWNSHOP_REPORTS_DOMAIN;

let pawnshop_reports_settings_domain =
  process.env.REACT_APP_PAWNSHOP_REPORTS_SETTINGS_DOMAIN;

let crdm_domain = process.env.REACT_APP_CRDM_SERVICE_DOMAIN;

let api_version = process.env.REACT_APP_API_VERSION;

export const pawnshop_reports_reader_host = `${pawnshop_reports_reader_domain}/api/v2/exec-dashboard`;

export const pawnshop_reports_reader_host_v3 = `${pawnshop_reports_reader_domain}/api/v3/exec-dashboard`;

export const pawnshop_reports_reader_host_v4 = `${pawnshop_reports_reader_domain}/api/v4/exec-dashboard`;

export const pawnshop_reports_settings_host = `${pawnshop_reports_settings_domain}/api/v2/ppg/reports`;

export const keycloak_client_path = process.env.REACT_APP_KEYCLOAK_CLIENT_PATH;

export const crdm_host = crdm_domain;
